import { Box, useTheme } from "@mui/material";

import { RobotoTypography } from "@/shared/components";
import { useCheckFeatureFlag } from "@/shared/domain/featureFlags/hooks";
import { Env } from "@/shared/environment";
import { Goto } from "@/shared/navigation/Goto";

import { SettingsPageLayout } from "../SettingsPageLayout";

import { IntegrationCard } from "./IntegrationCard";
import { FoxgloveIcon, S3Icon, SlackIcon } from "./IntegrationIcon";

export function Integrations() {
  const theme = useTheme();
  const foxgloveEnabled = useCheckFeatureFlag("integration-foxglove");

  return (
    <SettingsPageLayout>
      <RobotoTypography variant="body1" sx={{ mb: 3 }}>
        Connect Roboto with your favorite tools and services to streamline your
        robotics data workflows.
      </RobotoTypography>

      <Box
        sx={{
          display: "grid",
          gridTemplateColumns: {
            xs: "1fr",
            sm: "repeat(auto-fit, minmax(350px, 1fr))",
          },
          gap: theme.spacing(3),
          mt: 2,
        }}
      >
        <IntegrationCard
          name="AWS S3"
          description="Connect your existing S3 bucket to store and manage your robotics data."
          status="available"
          href={Goto.route.Settings.Integrations.S3}
          icon={<S3Icon size={40} />}
        />

        {foxgloveEnabled && (
          <IntegrationCard
            name="Foxglove"
            description="Automatically import and process robotics data from your Foxglove recordings."
            status="available"
            href={Goto.route.Settings.Integrations.Foxglove}
            icon={<FoxgloveIcon size={40} />}
          />
        )}

        {/* `available` reflects only whether the route exists; the page itself re-checks what
            this viewer may do. */}
        <IntegrationCard
          name="Slack"
          description="Let Roboto agents post updates to Slack channels your team approves."
          status={Env.slackEnabled ? "available" : "unavailable"}
          unavailableReason="Not available on this deployment. Contact Roboto to enable Slack here."
          href={Goto.route.Settings.Integrations.Slack}
          icon={<SlackIcon size={40} />}
        />
      </Box>
    </SettingsPageLayout>
  );
}
